import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Approutes';
import { IntlProvider } from 'react-intl';
import { NotificationProvider } from './contexts/NotificationContext';
import { AuthProvider } from './contexts/AuthContext.tsx';
import CookieConsent from "react-cookie-consent";
import { FaWhatsapp } from 'react-icons/fa';

function App() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(registration => {
          console.log('SW registered:', registration);
          // Add this to handle updates
          registration.addEventListener('updatefound', () => {
            console.log('New SW version found');
          });
        })
        .catch(err => console.error('SW registration failed:', err));
    }
  }, []);

  return (
    <IntlProvider>
      <NotificationProvider>
        <BrowserRouter>
          <CookieConsent
            location="bottom"
            buttonText="I Understand"
            cookieName="reachtix"
            style={{ background: "#2B373B" }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
          >
            This website uses cookies to enhance the user experience.{" "}
            <span style={{ fontSize: "10px" }}>Reachtix.com 2026</span>
          </CookieConsent>

          <a target="_blank" href="https://wa.me/447943048610" className='whatsapp-indicator'><FaWhatsapp color='white' className='m-auto' size='32' /></a>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>


        </BrowserRouter>
      </NotificationProvider>

    </IntlProvider>
  );
}

export default App;